import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import PonBoxDescriptEditingModal from './DescriptionEditingModal/PonBoxDescriptEditingModal';


const PonBoxDescriptConstruction = ({ open, onClose, content, snackbarOpen, snackbarMessage, snackbarClass,
  handleCloseSnackbar, copyToClipboard, cantonRefresh, setIsComponentСhangeCoorPonBox}) => {

  const [openModalEditing, setOpenModalEditing] = useState(false);

  const openModalEditingContent = () => {
    setOpenModalEditing(true);
  };  

  return (
    <Dialog open={open} className="dialogStyle">
    <DialogContent>
           <img src='./ponbox.png' width='30' height='30' style={{ marginRight: "5px" }} />
    <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #3d3d3d'}}>Информация о Пон-боксе</label>
    <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe' ,textShadow: '2px 2px 4px #3d3d3d'}}>{content.id}</span></label>
      <Button 
          style={{marginLeft: '10px', minWidth: '25px', width: '25px', minHeight: '25px', height: '25px' }}
          onClick={() => { copyToClipboard(content.id, "фоб"); }}>
          <FileCopyIcon style={{ color: '#e4c253'}}/>
        </Button>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Территория: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.canton} {content.region} {content.area}</span> </label>
     
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Пон-бокс: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.fobName}</span> </label>
      <br/>
       <label style={{ color: '#292929', fontWeight: 'bold' }}>
           Признак: 
           <span style={{ color: content.ether === 1 || content.pon === 1 || content.ktv === 1 ? '#bdab6f' : '#de858e',textShadow: '2px 2px 4px #3d3d3d' }}>
             {[
                content.pon === 1 && ' PON',
                content.ktv === 1 && ' KTV',
                content.ether === 1 && ' Ethernet'
             ]
              .filter(Boolean)
             .join(', ') || ' Нет'}
           </span>
        </label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      
     <div style={{ display: 'flex', alignItems: 'flex-start', gap: '5px', color: '#292929', fontWeight: 'bold' }}>
        <span>Делитель:</span>
        <div style={{ display: 'flex', flexDirection: 'column', color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>
          <span>{content.dividerModel}</span>
          {content.divider2Id !== 5 && <span>{content.dividerModel2}</span>}
        </div>
      </div>

        {content.pigtailCount !== 0 &&
          <>
          <label style={{ color: '#292929', fontWeight: 'bold'}}>Pigtail: <span style={{ color: '#bebebe',fontWeight: 'normal' ,textShadow: '2px 2px 4px #3d3d3d'}}>{content.polishingType} - {content.pigtailCount} кол.</span> </label>
          <br/> 
          </>
        } 
       {content.adapterCount !== 0 &&
          <label style={{ color: '#292929', fontWeight: 'bold'}}>Adapter: <span style={{ color: '#bebebe',fontWeight: 'normal' ,textShadow: '2px 2px 4px #3d3d3d'}}>{content.polishingType} - {content.adapterCount} кол.</span> </label>
       }

      
       
        {content.numberBox && (
          <>
           <br/>
          <label style={{ color: '#292929', fontWeight: 'bold' }}>
            Номер бокса: <span style={{ color: '#bebebe', fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.numberBox}</span>
          </label>
           <br/>
          </> 
        )}
       
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.description}</span></label>

      <hr className='horizontalLineDialog'/>
    </DialogContent>

    <DialogActions>
      <Button onClick={openModalEditingContent} class='buttonIsEditDialog'>
          Редактировать
      </Button>
    
      <Button onClick={onClose} class='buttonIsHideDrawer23'>
        Закрыть
      </Button>
    </DialogActions>

   {/* Snackbar */}
   <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />
      
      {/* Modal редактирование FobCanton*/}
      <PonBoxDescriptEditingModal
        open={openModalEditing}
        onClose={() => setOpenModalEditing(false)}
        onClose2={onClose}
        content={content}
        cantonRefresh={cantonRefresh}
        setIsComponentСhangeCoorPonBox={setIsComponentСhangeCoorPonBox}
      />   
    </Dialog> 
  );
}

export default PonBoxDescriptConstruction;